import script from "./CollectionView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CollectionView.vue?vue&type=script&lang=ts&setup=true"

import "./CollectionView.vue?vue&type=style&index=0&id=3ec8b667&scoped=true&lang=css"

import exportComponent from "E:\\Marianne\\workspace\\notion-cooks\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ec8b667"]])

export default __exports__